<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    title="编辑"
    width="600px"
    @close="$reset('form')"
  >
    <el-form ref="form" :model="esop" :rules="ruleValidate" class="form" label-width="100px">
      <el-form-item v-if="esop.pkId > 0" label="ESOP编号">
        <el-input v-model="esop.esopNo" disabled placeholder="请输入ESOP编号" />
      </el-form-item>
      <el-form-item label="ESOP名称" prop="esopName">
        <el-input v-model="esop.esopName" placeholder="请输入ESOP名称" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      esop: {
        pkId: 0,
        esopName: "",
      },
      ruleValidate: {
        esopName: { required: true, message: "请输入ESOP名称", trigger: "blur" },
      },
    };
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      if (row) {
        this.esop = Object.assign(this.esop, row);
      }
    },

    // 编辑
    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .save("basic", "esops", this.esop)
            .then((resp) => {
              this.submitLoading = false;
              if (resp.success) {
                this.$emit("save-success");
                this.$message.success("编辑成功");
                this.dialogVisible = false;
              }
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
